import {
  RedoShopifyCountryCode,
  tryCoalesceStringToRedoShopifyCountryCode,
} from "@redotech/redo-inventory-common/fulfillment-country-code";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { RpcClientContext } from "../../contexts/rpc";

export interface ExchangeAddressLockedValues {
  countryCode?: RedoShopifyCountryCode;
}

export const useExchangeAddressLock = ({
  draftReturnId,
  returnId,
  enabled = true,
}: {
  draftReturnId?: string;
  returnId?: string;
  enabled?: boolean;
}): ExchangeAddressLockedValues | undefined => {
  const client = useContext(RpcClientContext);
  const hasId = !!draftReturnId || !!returnId;

  const { data } = useQuery({
    queryKey: ["exchangeAddressLock", draftReturnId, returnId],
    queryFn: async () => {
      if (!client) {
        throw new Error("Client is missing");
      }
      return await client.getExchangeAddressLock({ draftReturnId, returnId });
    },
    enabled: enabled && !!client && hasId,
    staleTime: Infinity,
  });

  // A disabled query still returns another form's cached result.
  const countryCode = enabled ? data?.lockedValues.countryCode : undefined;
  if (!countryCode) {
    return undefined;
  }
  return {
    countryCode: tryCoalesceStringToRedoShopifyCountryCode(countryCode),
  };
};
